module.exports = "/_next/static/images/Hero-7634169d2bd7fa74f06ea0139e6c809f.webp";